import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./RepairFacilitiesSearch.html';
import styles from './RepairFacilitiesSearch-hashed.scss';

export default {
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        onBack: '&',
        selectedRepairFacility: '=',
        repairFacilities: '=',
        searchCenter: '=',
        onSearchWaypointChange: '&',
        onRepairFacilitiesRefresh: '&',
        onMapFacilitySelect: '&',
        policyLocation: '<',
        lossLocation: '<',
        myLocation: '<',
        selectVendor: '<',
        enableSearch: '<',
        selectStaticAddress: '&'
    }
};
